import Immutable from "immutable";

export class SessionRecord extends Immutable.Record({
  /** @memberof SessionRecord# */
  isAuthenticating: false,
  /** @memberof SessionRecord# */
  isAuthenticated: false,
  requireOAuth: false,
  hasAuthenticationError: false,
  errorMessage: "",
  isPasswordExpired: false,
  requiresMfa: false,
  sessionTimeout: null
}) {}

export const session = (state = new SessionRecord(), action) => {
  switch (action.type) {
    case "SMS_VERIFY_REQUEST":
    case "LOGIN_REQUEST":
      return state.set("isAuthenticating", true);

    case "SET_REQUIRES_MFA":
      return state.merge({
        isAuthenticating: false,
        requiresMfa: true,
        isAuthenticated: false,
        requireOAuth: false
      });

    case "UPDATE_SESSION_AFTER_LOGIN":
      return state.merge({
        isAuthenticating: false,
        isAuthenticated: true,
        requireOAuth: false
      });

    case "SMS_REQUEST":
      return state.merge({
        requireOAuth: true,
        isAuthenticating: true
      });

    case "SMS_SUCCESS":
    case "SMS_FAILURE":
      return state.merge({
        isAuthenticating: false
      });

    case "LOGIN_FAILURE":
      if (action.response.status === 303) {
        return state.merge({
          isPasswordExpired: true,
          isAuthenticating: false
        });
      }

      if (action.response.status === 418) {
        return state.merge({
          requireOAuth: true,
          isAuthenticating: false
        });
      }

      return state.merge({
        isAuthenticating: false
      });
    case "RESET_EXPIRED_PASSWORD_SUCCESS":
      return state.merge({
        isPasswordExpired: false,
        isAuthenticating: false,
        requireOAuth: false
      });
    case "SMS_VERIFY_SUCCESS":
      return state.merge({
        isAuthenticating: false
      });
    case "RESET_NOTIFICATION_ERROR":
      return state.merge({
        hasAuthenticationError: false,
        errorMessage: ""
      });

    case "RESET_SESSION_TIMEOUT": {
      clearTimeout(state.get("sessionTimeout"));
      const { sessionTimeout } = action.payload;

      return state.merge({
        sessionTimeout
      });
    }

    case "ENFORCE_MFA_ACTIVATE_TFA_REQUEST":
      return state.merge({
        isAuthenticating: true
      });
    case "ENFORCE_MFA_ACTIVATE_TFA_FAILURE":
      if (action.response.status === 418) {
        return state.merge({
          isAuthenticating: false,
          errorMessage: "",
          hasAuthenticationError: false
        });
      }

      return state.merge({
        isAuthenticated: false,
        errorMessage: action.response.data.message,
        hasAuthenticationError: true,
        isAuthenticating: false
      });
    case "SMS_VERIFY_FAILURE":

      if (action.response.status === 303) {
        return state.merge({
          isPasswordExpired: true,
          isAuthenticating: false
        });
      }

      return state.merge({
        isAuthenticating: false,
        hasAuthenticationError: true,
        errorMessage: action.response.data.message
      });
    case "RESET_OATH_REQUIREMENTS":
      return state.set("requireOAuth", false);
    case "ENFORCE_MFA_SMS_VERIFY_REQUEST":
      return state.set("isAuthenticating", true);
    case "ENFORCE_MFA_SMS_VERIFY_SUCCESS":
      return state.merge({
        isAuthenticatingPage: false,
        isAuthenticating: false,
        isAuthenticated: false
      });
    case "ENFORCE_MFA_SMS_VERIFY_FAILURE":
      return state.merge({
        isAuthenticating: false,
        hasAuthenticationError: true,
        errorMessage: action.response.data.message
      });
    default:
      return state;
    case "UNAUTHENTICATE":
      return state.set("isAuthenticated", false);
  }
};
